import { LockRounded, Notifications, NotificationsActive } from '@mui/icons-material';
import { Paper } from '@mui/material';
import { IconButton as IconButtonOutlined } from 'app/components';
import { LockOpenRoundedIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { GUARD_ACTIONS, GUARD_BIT_INDICES } from '../TabPanelCondition.constants';
import { GuardState } from '../TabPanelCondition.types';
import { alarmBlockStyle } from '../TabPanelConditionStyle';
import { UzaRelayControl } from './UzaRelayControl';
const IconButtonComponent = forwardRef(function IconButtonComponent(props, ref) {
    return React.createElement("div", Object.assign({ ref: ref }, props));
});
export const AlarmSection = ({ transportItem, conditionItem, galileoskyDevice, guardData, guardPermission, relayPermission = false, relayDisabled, onGuardClick, config, }) => {
    var _a, _b;
    const guardStatusAlarmBit = guardData.guardStatus[GUARD_BIT_INDICES.ALARM];
    const guardOutAlarmBit = guardData.guardOut[GUARD_BIT_INDICES.ALARM];
    const isGalileoskyDevice = galileoskyDevice && config.transportDeviceTypes[transportItem.device_type] === 'galileosky';
    const hasUzaRelay = !!transportItem.ground_sensor;
    return (React.createElement(Paper, { variant: 'outlined', sx: alarmBlockStyle },
        React.createElement("div", { className: 'MuiPaperAlert-alarm' },
            React.createElement(AlarmNotificationButton, { guardStatusBit: guardStatusAlarmBit, guardStatusNumber: guardData.guardStatusNumber, galileoskyDevice: galileoskyDevice, guardPermission: guardPermission, isGalileoskyDevice: isGalileoskyDevice, onAlarmClick: () => onGuardClick(GUARD_ACTIONS.ALARM_DISABLE), config: config })),
        hasUzaRelay && (React.createElement("div", { className: 'MuiPaperAlert-alarm' },
            React.createElement(IconButtonComponent, null,
                React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', component: 'div', disabled: relayDisabled },
                    React.createElement(UzaRelayControl, { uzaStatus: (_b = (_a = conditionItem.data) === null || _a === void 0 ? void 0 : _a.uza_status) !== null && _b !== void 0 ? _b : -1, disabled: relayDisabled, hasPermission: relayPermission, hasDevice: galileoskyDevice, onToggle: onGuardClick }))))),
        React.createElement("div", { className: 'MuiPaperAlert-alarm' },
            React.createElement(GuardLockButton, { guardOutBit: guardOutAlarmBit, guardOutNumber: guardData.guardOutNumber, galileoskyDevice: galileoskyDevice, guardPermission: guardPermission, isGalileoskyDevice: isGalileoskyDevice, onLockClick: (action) => onGuardClick(action), config: config }))));
};
const AlarmNotificationButton = ({ guardStatusBit, guardStatusNumber, galileoskyDevice, guardPermission, isGalileoskyDevice, onAlarmClick, config, }) => {
    if (!galileoskyDevice) {
        return (React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', disabled: true },
            React.createElement(Notifications, null)));
    }
    if (guardStatusNumber === config.conditions.guard_status.default) {
        return (React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', disabled: true },
            React.createElement(Notifications, null)));
    }
    if (guardStatusBit === GuardState.UNLOCKED) {
        return (React.createElement(IconButtonComponent, null,
            React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', disabled: true },
                React.createElement(Notifications, null))));
    }
    return (React.createElement(IconButtonComponent, null,
        React.createElement(IconButtonOutlined, { size: 'medium', color: 'error', disabled: !guardPermission || !isGalileoskyDevice, onClick: onAlarmClick },
            React.createElement(NotificationsActive, null))));
};
const GuardLockButton = ({ guardOutBit, guardOutNumber, galileoskyDevice, guardPermission, isGalileoskyDevice, onLockClick, config, }) => {
    if (!galileoskyDevice) {
        return (React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', disabled: true },
            React.createElement(LockRounded, null)));
    }
    if (guardOutNumber === config.conditions.guard_out.default) {
        return (React.createElement(IconButtonOutlined, { size: 'medium', color: 'inherit', disabled: true },
            React.createElement(LockRounded, null)));
    }
    const isLocked = guardOutBit === GuardState.LOCKED;
    const Icon = isLocked ? LockRounded : LockOpenRoundedIcon;
    const color = isLocked ? 'primary' : 'inherit';
    const action = isLocked ? GUARD_ACTIONS.GUARD_LOCK : GUARD_ACTIONS.GUARD_UNLOCK;
    return (React.createElement(IconButtonComponent, null,
        React.createElement(IconButtonOutlined, { size: 'medium', color: color, disabled: !guardPermission || !isGalileoskyDevice, onClick: () => onLockClick(action) },
            React.createElement(Icon, null))));
};
